<template>
  <div class="main">
    <p class="text-left">
      <img src="../assets/slide1.png" height=240 class="card-img" style="margin-bottom:8px" alt="..."/>
      "自由"なトラットリア「リベルタ」<br>
      店名はイタリア語で ゛自由゛ という意味を表します。<br />
      それぞれのお客様がそれぞれの用途で自由に来店して頂きたいという思いから名付けました。<br />
      ご家族や普段使いのお客様にはカジュアルでお値打ちなセット料理やアラカルトを・・・<br />
      記念日のお客様には半個室でいつもと違ったテーブルコーディネートと豪華フルコースを・・・<br />
      お子様からおじいちゃん、おばあちゃんまで楽しめる幅広いメニューを取り揃えております。<br />
      あなた様だけのリベルタな時間をお過ごしください。
    </p>
    <div class="card-body">
      <h5 class="card-title">アクセス</h5>
      <p class="card-text text-left">
        <i class="fa fa-home"></i>
        〒468-0007 名古屋市天白区植田本町1-1311ドゥエルハウス植田１Ｆ<br />
        <br />
        地下鉄鶴舞線 植田駅 徒歩15分<br />
        地下鉄鶴舞線 植田駅 車4分<br />
        <span style="color:red">
            カーナビでお越しの方は、"住所検索"でお願いいたします<br />
            ※電話番号を入力されますと、移転前の場所に設定されてしまいます
        </span>
        <br /><br />
        2012年6月6日、植田に移転しました！</p>
    </div>
    <div class="card-body">
      <h5 class="card-title">営業時間のご案内</h5>
      <p class="card-text  text-left">
        ランチ / 11：00～15：00(L.O14：00)<br />
        ディナー / 17：30～22：30(L.O21：30)<br />
        ※匠コースとプレミアムコースはL.O21:00<br />
        ※ドリンク、ドルチェはL.O22:00<br />
        定休日 / 水曜日<br />
      </p>
    </div>
    <div class="card-body">
      <h5 class="card-title">Contact Us</h5>
      <p class="card-text text-left">
      <a href="tel:052-848-1070"><h4><i class="fa fa-phone"></i> 052-848-1070</h4></a>
        <img src="../assets/img_staff.jpg" height=240 class="card-img" alt="..."/>
        リベルタスタッフはお客様の「～して欲しい」に全力でお答えいたします。また、特別な日を素敵に演出するためのメッセージ入りケーキなど、メニュー以外のお料理もご要望に応じて、できる限りご用意させて頂きますので、お気軽にお問い合わせ下さい。
        <br />
      </p>
    </div>
  </div>
</template>
<script>
// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  created () {
    this.$store.state.title = '店舗情報'
  },
  mounted() {
    $('#navbarSupportedContent').collapse({
      toggle: false
    }).collapse('hide')
  }
}
</script>
<style scoped>
small {
  color:#fb6e14;
}
a{
  color:#CC6633;
}
a:link {
  color:#CC6633;
}

.main{
  margin:8px;
}
</style>
